export default __webpack_public_path__ + "static/visually-appealing-desktop-1-30abbb7bdd4110113af115d20023502e.webp";